import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function IsNegotiable() {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
  
  function oncheckBoxCheked({ target }) {
    setSearchObject({
      ...searchObject,
      [target.name]: target.checked
    });
  }

  return (
    <fieldset>
      <legend>{t("Include negotiable availability")}</legend>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          name="isNegotiable"
          checked={searchObject.isNegotiable}
          onChange={oncheckBoxCheked}
        />
        <label className="form-check-label" for="flexCheckDefault">
          {t("Include negotiable availability")}
        </label>
      </div>
    </fieldset>
  );
}
